import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  authorizedGet,
  authorizedPost,
} from "../../../Config/networkWithToken";
import configuration from "../../../Config/configuration";
import MessageBar, {
  config,
  DOBASEURL,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../../utils/helper";
import Spinner from "../../../Components/Spinner/Spinner";
import { MdHistory } from "react-icons/md";
import { PiArrowsCounterClockwiseBold } from "react-icons/pi";
import { FaUserCheck, FaUserTimes } from "react-icons/fa";
import Images from "../../../utils/images";
import RejectModel from "../../../Components/RejectModel/RejectModel";

// One suggestion card. Approve/Decline buttons only render on the
// "Coordinator Suggestion" tab (pending items) -- the other 3 tabs are
// history/read views.
const CoordinatorSuggestionCard = ({
  request,
  activeTab,
  adminId,
  onDecisionMade,
}) => {
  const [loadingApprove, setLoadingApprove] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const canManage = role === "admin" || role === "superAdmin";

  const getTimeAgoLabel = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    if (diffInDays <= 3) return "3 days ago";
    if (diffInDays <= 7) return "1 week ago";
    if (diffInDays <= 14) return "2 weeks ago";
    if (diffInDays <= 30) return "1 month ago";
    if (diffInDays <= 60) return "2 months ago";
    if (diffInDays <= 90) return "3 months ago";
    if (diffInDays <= 180) return "6 months ago";
    return "Over 6 months ago";
  };

  const getDateBadgeColor = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "bg-lime-500";
    if (diffInDays === 1) return "bg-fuchsia-500";
    if (diffInDays <= 3) return "bg-blue-500";
    if (diffInDays <= 7) return "bg-yellow-500";
    if (diffInDays <= 14) return "bg-pink-700";
    if (diffInDays <= 30) return "bg-cyan-500";
    if (diffInDays <= 60) return "bg-teal-500";
    if (diffInDays <= 90) return "bg-red-500";
    if (diffInDays <= 180) return "bg-purple-600";
    return "bg-gray-500";
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "N/A";

  const handleDecision = async (decision) => {
    if (decision === "approve") setLoadingApprove(true);
    else setLoadingDecline(true);
    try {
      const data = {
        matchId: request.id,
        adminId,
        decision,
        comments: decision === "reject" ? comment : undefined,
      };
      const res = await authorizedPost(
        configuration.apis.approveCoordinatorSuggestion,
        data,
        config,
      );
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        setIsCommentSectionOpen(false);
        setComment("");
        onDecisionMade?.(res?.data?.data);
      } else {
        errorNotify(res?.data?.message || "Failed to update suggestion.");
      }
    } catch (err) {
      console.log(err);
      errorNotify("An error occurred, please try again.");
    } finally {
      setLoadingApprove(false);
      setLoadingDecline(false);
    }
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      handleDecision("reject");
    }
  };

  return (
    <div className="font-jost relative flex w-full flex-col items-center gap-2 rounded-xl bg-white p-2 shadow-md md:w-[30%] md:justify-around">
      <div className="flex w-full flex-col items-center gap-2 p-2 md:justify-around xl:flex-row">
        <div className="flex flex-row justify-around">
          <div className="flex flex-col items-center text-center">
            <Link to={`/married-users/viewProfile/${request?.matchUser?.id}`}>
              <img
                src={
                  request?.matchUser?.profileImage?.length > 0
                    ? DOBASEURL + request?.matchUser?.profileImage[0]
                    : request?.matchUser?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="Match User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
              {request?.matchUser?.name}
            </span>
          </div>
          <div className="flex">
            <PiArrowsCounterClockwiseBold
              className="mt-5"
              style={{ fontSize: "40px", color: "#ffbb33" }}
            />
          </div>
          <div className="flex flex-col items-center text-center">
            <Link to={`/married-users/viewProfile/${request?.user?.id}`}>
              <img
                src={
                  request?.user?.profileImage?.length > 0
                    ? DOBASEURL + request?.user?.profileImage[0]
                    : request?.user?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
              {request?.user?.name}
            </span>
          </div>
        </div>

        {activeTab === 0 && canManage && (
          <div className="flex w-full flex-row items-center justify-center gap-3 lg:w-[20%] xl:flex-col">
            <button
              onClick={() => handleDecision("approve")}
              disabled={loadingApprove}
              className="flex items-center justify-center rounded-full bg-green-500 px-2 py-2 text-white transition hover:bg-green-600 disabled:opacity-50"
            >
              {loadingApprove ? <Spinner size="small" /> : <FaUserCheck />}
            </button>
            <button
              onClick={() => setIsCommentSectionOpen(true)}
              disabled={loadingDecline}
              className="flex items-center justify-center rounded-full bg-red-500 px-2 py-2 text-white transition hover:bg-red-600 disabled:opacity-50"
            >
              {loadingDecline ? <Spinner size="small" /> : <FaUserTimes />}
            </button>
          </div>
        )}
      </div>

      <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 text-xs text-gray-800 shadow-sm">
        <div className="flex items-center gap-2">
          <span className="font-semibold">Suggested By:</span>
          <span className="text-blue-600">
            {request?.coordinatorName || "N/A"}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="font-semibold">Proposal Date:</span>
          <span className="text-black">{formatDate(request?.sentAt)}</span>
          {request?.sentAt && (
            <span
              className={`ml-1 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium text-white shadow-sm ${getDateBadgeColor(request?.sentAt)}`}
            >
              <MdHistory className="text-[12px]" />
              {getTimeAgoLabel(request?.sentAt)}
            </span>
          )}
        </div>

        {activeTab === 1 && (
          <p className="font-semibold">
            Approved By:{" "}
            <span className="font-normal text-green-600">
              {request?.approvedByAdminName || "N/A"}
            </span>
          </p>
        )}

        {activeTab === 2 && (
          <p className="font-semibold">
            Declined Reason:{" "}
            <span className="font-normal text-red-400">
              {request?.coordinatorRejectedComments || "N/A"}
            </span>
          </p>
        )}

        {activeTab === 3 && (
          <p className="font-semibold">
            Approved By:{" "}
            <span className="font-normal text-green-600">
              {request?.approvedByAdminName || "N/A"}
            </span>
          </p>
        )}

        {activeTab === 4 && (
          <>
            <p className="font-semibold">
              Approved By:{" "}
              <span className="font-normal text-green-600">
                {request?.approvedByAdminName || "N/A"}
              </span>
            </p>
            {request?.user?.userdecision === "rejected" && (
              <p className="font-semibold">
                {request?.user?.name} Declined:{" "}
                <span className="font-normal text-red-400">
                  {request?.user?.userComments || "N/A"}
                </span>
              </p>
            )}
            {request?.matchUser?.matchedUserdecision === "rejected" && (
              <p className="font-semibold">
                {request?.matchUser?.name} Declined:{" "}
                <span className="font-normal text-red-400">
                  {request?.matchUser?.matchedUserComments || "N/A"}
                </span>
              </p>
            )}
          </>
        )}
      </div>

      <p className="text-xs text-gray-400">Click profile to see full details</p>

      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={(e) => {
              setError(false);
              setComment(e.target.value);
            }}
            closeModal={() => {
              setIsCommentSectionOpen(false);
              setComment("");
              setError(false);
            }}
            error={error}
            handleSaveComment={handleSaveComment}
            isShowDropdown={true}
          />
        </div>
      )}
    </div>
  );
};

const CoordinatorSuggestion = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [coordinatorSuggestion, setCoordinatorSuggestion] = useState([]);
  const [adminAccepted, setAdminAccepted] = useState([]);
  const [adminDeclined, setAdminDeclined] = useState([]);
  const [mutuallyAccepted, setMutuallyAccepted] = useState([]);
  const [userDeclined, setUserDeclined] = useState([]);

  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");

  const applyResponse = (data) => {
    setCoordinatorSuggestion(data?.coordinatorSuggestion || []);
    setAdminAccepted(data?.adminAccepted || []);
    setAdminDeclined(data?.adminDeclined || []);
    setMutuallyAccepted(data?.mutuallyAccepted || []);
    setUserDeclined(data?.userDeclined || []);
  };

  const fetchCoordinatorSuggestions = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getCoordinatorSuggestions}?adminId=${adminId}`,
        config,
      );
      if (res?.data?.status) {
        applyResponse(res?.data?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoordinatorSuggestions();
  }, [adminId]);

  const tabList = [
    { name: "Coordinator Suggestion", data: coordinatorSuggestion },
    { name: "Admin Accepted", data: adminAccepted },
    { name: "Admin Declined", data: adminDeclined },
    { name: "Mutually Accepted", data: mutuallyAccepted },
    { name: "User Declined", data: userDeclined },
  ];

  const currentData = tabList[activeTab]?.data || [];

  return (
    <div className="font-jost flex w-full flex-col p-4">
      <div className="mb-4 flex flex-col items-center gap-2 md:flex-row md:items-end md:justify-between">
        <ul className="flex flex-col border-b border-gray-300 md:flex-row">
          {tabList.map((tab, index) => (
            <li
              key={index}
              className={`cursor-pointer px-4 py-2 text-center transition-all sm:text-xs md:text-base ${
                activeTab === index
                  ? "border-b-2 border-textYellow font-semibold text-textYellow"
                  : "text-textGreen hover:bg-gray-100 hover:text-textYellow"
              }`}
              onClick={() => !loading && setActiveTab(index)}
            >
              {tab.name} ({tab.data.length})
            </li>
          ))}
        </ul>
      </div>

      {loading ? (
        <div className="flex h-[50vh] w-full items-center justify-center">
          <Spinner />
        </div>
      ) : currentData.length > 0 ? (
        <div className="flex flex-wrap gap-4 p-2">
          {currentData.map((request) => (
            <CoordinatorSuggestionCard
              key={request.id}
              request={request}
              activeTab={activeTab}
              adminId={adminId}
              onDecisionMade={applyResponse}
            />
          ))}
        </div>
      ) : (
        <div className="flex w-full items-center justify-center py-10">
          <p className="text-center text-gray-500">
            {activeTab === 0
              ? "No pending coordinator suggestions."
              : activeTab === 1
                ? "No admin-accepted suggestions yet."
                : activeTab === 2
                  ? "No declined suggestions."
                  : activeTab === 3
                    ? "No mutually accepted suggestions yet."
                    : "No user declined suggestions."}
          </p>
        </div>
      )}
      <MessageBar />
    </div>
  );
};

export default CoordinatorSuggestion;